import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { NoAccountScreen } from './BankErrorScreen';
import { SignUpWrapper } from 'stash/components/sign-up/SignUpScreenLayout';
import { Text, Checkbox, Box, PrimaryButton, ErrorMessage, Link } from '@stashinvest/ui';
import { BanjoString } from '@stashinvest/react-banjo';
import { Form, Formik, Field } from 'formik';
import { createDebitAccount } from 'stash/actions/api/harmonyBank';
import {
	customerAgreementScreenView,
	customerAgreementSecondaryCta,
	customerAgreementCheckboxChange,
	customerDepositAgreementCheckboxChange,
	customerEsignCheckboxChange,
	customerStockbackTermsCheckboxChange,
	noToDebitScreenScreenView,
	noToDebitScreenCta,
	noToDebitScreenSecondaryCta,
} from 'stash/actions/debitSignUpTrackingEvents';
import {
	STRIDE_BANK_PRIVACY_POLICY,
	STRIDE_DEPOSIT_ACCOUNT_AGREEMENT,
	STASH_ESIGN_AGREEMENT,
	STRIDE_STOCK_BACK_REWARDS_DISCLOSURES,
} from 'stash/constants';

const DisclosureText = styled(Text.BodySmall).attrs({ mb: 'm' })``;
const mapStateToProps = (state) => ({
	debitAddress: state.application.debitSignUp.address,
});

const mapDispatchToProps = {
	createDebitAccount,
	customerAgreementScreenView,
	customerAgreementSecondaryCta,
	customerAgreementCheckboxChange,
	customerDepositAgreementCheckboxChange,
	customerEsignCheckboxChange,
	customerStockbackTermsCheckboxChange,
	noToDebitScreenScreenView,
	noToDebitScreenCta,
	noToDebitScreenSecondaryCta,
};

export function DebitSignUpCreateAccount(props) {
	const [accountScreenVisible, showAccountScreen] = useState(true);
	const [loader, showLoader] = useState(false);
	const {
		customerAgreementScreenView,
		customerDepositAgreementCheckboxChange,
		customerEsignCheckboxChange,
		customerStockbackTermsCheckboxChange,
		noToDebitScreenScreenView,
		noToDebitScreenCta,
		noToDebitScreenSecondaryCta,
	} = props;

	useEffect(() => {
		customerAgreementScreenView();
	}, [customerAgreementScreenView]);

	return (
		<React.Fragment>
			{accountScreenVisible === true ? (
				<SignUpWrapper>
					<Box maxWidth="36rem" mx="auto">
						<Text.H1 size="3" mb="xs">
							Please review and accept the Stash debit account agreements.
						</Text.H1>
						<Formik
							initialValues={{
								disclosure1: false,
								disclosure2: false,
								disclosure3: false,
							}}
							onSubmit={() => {
								showLoader(true);
								props.createDebitAccount(props.debitAddress).then((account) => {
									showLoader(false);
									if (account.account.status !== 'normal') {
										props.history.push('/debit');
									} else {
										props.completeStep();
									}
								});
							}}
						>
							{(props) => {
								return (
									<Form mb="m">
										<Field name="disclosure1">
											{({ field }) => (
												<Checkbox
													name="disclosure1"
													value="disclosure1"
													alignItems="top"
													mt="m"
													{...field}
													onChange={(e) => {
														customerDepositAgreementCheckboxChange();
														props.handleChange(e);
													}}
												>
													<Box mb="s">
														I agree to the{' '}
														<Link href={STRIDE_DEPOSIT_ACCOUNT_AGREEMENT} target="_blank">
															Deposit Account Agreement
														</Link>{' '}
														and the{' '}
														<Link href={STRIDE_BANK_PRIVACY_POLICY} target="_blank">
															Stride Bank Privacy Policy
														</Link>
														.
													</Box>
												</Checkbox>
											)}
										</Field>
										<Field name="disclosure2">
											{({ field }) => (
												<Checkbox
													name="disclosure2"
													value="disclosure2"
													alignItems="top"
													mt="m"
													{...field}
													onChange={(e) => {
														customerEsignCheckboxChange();
														props.handleChange(e);
													}}
												>
													<Box mb="s">
														I agree to the{' '}
														<Link href={STASH_ESIGN_AGREEMENT} target="_blank">
															Stash E-Sign Agreement
														</Link>
														.
													</Box>
												</Checkbox>
											)}
										</Field>

										<Field name="disclosure3">
											{({ field }) => (
												<Checkbox
													name="disclosure3"
													value="disclosure3"
													alignItems="top"
													mt="m"
													{...field}
													onChange={(e) => {
														customerStockbackTermsCheckboxChange();
														props.handleChange(e);
													}}
												>
													<Box mb="s">
														I agree to the{' '}
														<Link
															href={STRIDE_STOCK_BACK_REWARDS_DISCLOSURES}
															target="_blank"
														>
															Stock-Back® Card Terms and Conditions
														</Link>
														.
													</Box>
												</Checkbox>
											)}
										</Field>
										{props.errors.amount && (
											<ErrorMessage>{props.errors.disclosure}</ErrorMessage>
										)}
										<PrimaryButton
											type="submit"
											loading={loader}
											disabled={
												(props.values.disclosure1 &&
													props.values.disclosure2 &&
													props.values.disclosure3) === false
											}
											mb="xs"
										>
											Accept
										</PrimaryButton>

										<DisclosureText mt="xl" mb="m">
											By clicking “Accept” you are giving approval for Stash to create
											your new banking account.
										</DisclosureText>
										<DisclosureText mb="m">
											{' '}
											<BanjoString stringId="information/disclose/genericBankMention" />{' '}
											The Stash Stock-Back® Debit Mastercard® is issued by Stride Bank
											pursuant to license from Mastercard International. Mastercard and
											the circles design are registered trademarks of Mastercard
											International Incorporated. Any earned Stock-Back® will be held in
											your Stash Invest account. Investment products and services provided
											by Stash Investments LLC and are Not FDIC Insured, Not Bank
											Guaranteed, and May Lose Value.
										</DisclosureText>
									</Form>
								);
							}}
						</Formik>
					</Box>
				</SignUpWrapper>
			) : (
				<NoAccountScreen
					onMount={noToDebitScreenScreenView}
					ctaCallback={() => {
						showAccountScreen(true);
						noToDebitScreenCta();
					}}
					secondaryCtaCallback={noToDebitScreenSecondaryCta}
				/>
			)}
		</React.Fragment>
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(DebitSignUpCreateAccount);
